import React from "react";

import BaseComponent from "@js/components/base_component.jsx";

import { Screen, ScreenHeader, ScreenBody, screenConnect } from "@screen";
import { ModalButton } from "@modal";

import { ceScreenViewRenderedPreviewCancel } from "@js/actions/studio/campaign_content_section/screen_view_rendered_preview.js";

class ScreenViewRenderedPreview extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      loadingImage: true,
    };
  }

  finishLoadingImage() {
    this.setState({
      loadingImage: false,
    });
  }

  openImageInNewTab() {
    var win = window.open(this.props.previewURL, "_blank");
    win.focus();
  }

  render() {
    return (
      <Screen>
        <ScreenHeader>
          <div
            style={{
              paddingLeft: "19px",
              paddingTop: "12px",
              display: "inline-block",
              float: "left",
            }}
          />
          <div
            style={{
              paddingRight: "19px",
              paddingTop: "12px",
              display: "inline-block",
              float: "right",
            }}
          >
            <ModalButton
              onClick={() =>
                this.props.dispatch(ceScreenViewRenderedPreviewCancel())
              }
              text={t("buttons.cancel")}
              diminished
            />
          </div>
        </ScreenHeader>
        <ScreenBody style={{ backgroundColor: "#EEE" }}>
          <img
            src={this.props.previewURL}
            alt={t(
              "phrases.react_content.action_dropdown.rendered_preview_alt",
            )}
            style={{
              width: "100%",
              maxWidth: "900px",
              display: this.state.loadingImage ? "none" : "block",
              pointerEvents: "none",
              marginLeft: "auto",
              marginRight: "auto",
              backgroundColor: "#FFF",
            }}
            onLoad={this.finishLoadingImage}
          />
        </ScreenBody>
      </Screen>
    );
  }
}

export default screenConnect(ScreenViewRenderedPreview);
